<template>
<div>
  <p class="tishi" v-if="data.type === 1">订阅后即可查看本文全部详细内容，在服务期限内老师可能随时更新，敬请关注</p>
  <p class="tishi" v-if="data.type === 2">此为付费文章，不提供后续追加服务，订阅后即可查看全文内容</p>
	<div class="discount_idea clearfix">
		<p class="left">优惠信息：</p>
		<p class="left nospecial" v-if="!promotion">无优惠信息</p>
		<p class="left isspecial" v-else-if="promotion.type === 1">
			<span>{{ promotion.start }}</span>至<span>{{ promotion.end }}</span> 前订阅用户可享受<span>{{ promotion.discount }}折优惠</span>
		</p>
		<p class="left isspecial" v-else-if="promotion.type === 2">
			前<span>{{ promotion.max }}</span>名订阅用户享受<span>{{ promotion.discount }}折优惠</span>，<template v-if="promotion.max - promotion.use > 0">目前还有<span>{{ promotion.max - promotion.use }}</span>个优惠名额</template><template v-else>已无优惠名额</template>
		</p>
		<p class="left isspecial" v-else-if="promotion.type === 3">
			{{ promotion.start }}至{{ promotion.end }}，在本直播室{{ this.promotion.consumeType | payType }}消费满<span>{{ promotion.gcoins }}元，</span>可享受<span>{{ promotion.discount }}折优惠</span>
		</p>
	</div>
  <div class="new_price">
		<span>订阅价格：</span>
		<span>{{ data.gcoins }}</span> 
		<span>G币</span>
	</div>
	<div class="level-discount clearfix" v-if="hasDiscount">
		<span class="left">专享折扣：</span>
		<span class="left">实付满100可享受折上{{ authUser.normalLevel | levelDiscount }}折</span>
	</div>
  <div class="btn_wrap yf-text_14">
		<button v-if="!authUser || data.status === 1" class="pay_submit" @click="submit" type="button">立即购买</button>
		<button v-else-if="data.status === 2" class="stopserver" type="button">已下架</button>
		<button v-else-if="data.status === 4" class="stopserver" type="button">已停止服务</button>
		<span v-if="data.status === 1 && data.stopTime"><i class="sanjiao"></i>{{ data.stopTime | stopTime }}</span>
	</div>
	<div class="easy_info">
		<p class="info">简介：</p>
		<p class="detail">{{ data.desc + '   --所有内容和信息，仅代表个人观点，仅供阅读交流，不构成投资建议，不作为买卖依据，据此操作风险自负' }}</p>
	</div>
</div>
</template>

<script>
import moment from 'moment'
import Dialog from '@/utils/Dialog'
import { levelDiscount } from '@/utils/Filters'

export default {
  name: 'components-article-buy',
  props: {
    data: {
    	type: Object,
    	default: function () {
    		return {}
    	}
    },
    promotion: {
    	type: Object,
    	default: function () {
    		return {}
    	}
    }
	},
  methods: {
    submit () {
	  	// 判断是否登陆
  		if(!this.$isLogin()) {
  			Dialog.login()
  			return false
			}
			this.$axios._post('/Article/Verify', { id: this.data.id }).then(({ fla }) => {
				// 优惠
				let price = fla ? this.data.promotionGcoins : this.data.gcoins
				// 专享折扣
				if (price >= 100 && this.data.isDiscount && this.authUser.normalLevel > 2) {
					price = Math.round(this.$options.filters.levelDiscount(this.authUser.normalLevel) / 10 * price)
				}

				Dialog.order({
					type: 2,
					title: this.data.title,
					date: this.data.endDate ? `${this.data.createAt}至${this.data.endDate}` : null,
					price,
					teacher: this.data.userId
				}, (data) => {
					// 确认订单回调函数
					let params = {
						id: this.$route.params.id,
						gcoins: data.gcoins,
						voucher_id: data.voucher > 0 ? data.voucher : 0
					}
					// console.log(0, params)
					this.$axios._post('/Article/Pay', params).then(() => {
						Dialog.alert('购买成功！', {
							type: 'success'
						}).then(() => {
							window.location.reload()
						})
					}).catch(err => {
						console.log(err)
					})
				})
			})
	  }
  },
  filters: {
    stopTime (v) {
      let du = moment.duration(moment(v) - moment(), 'ms'),
					days = du.get('days'),
					hours = du.get('hours'),
					mins = du.get('minutes')
      return `在${days}天${hours}小时${mins}分钟后停止购买`
    },
    payType (v) {
      switch (v) {
        case 0:
          return '累计'
        case 1:
          return '学堂投票'
        case 2:
          return '学堂提问'
        case 3:
          return '查看纸条'
        case 4:
          return '查看文章'
        case 5:
          return '学堂送礼'
        case 7:
          return '购买视频'
        case 9:
          return '购买VIP'
        case 10:
          return '购买付费观点'
        default:
          return '未知类型'
      }
		},
		levelDiscount
	},
	computed: {
		authUser () {
			return this.$store.state.user.data
		},
		hasDiscount () {
			return this.authUser && this.data.isDiscount && this.authUser.type !== 1 && this.authUser.normalLevel > 2 && this.data.gcoins > 99
		}
	}
}
</script>

<style lang="less" scoped>
.tishi { color: #ff6600; text-align: center; font-size: 16px; line-height: 73px; }
.discount_idea { padding-bottom: 20px;
	> p:nth-child(1) { width: 92px; text-align: right; font-size: 14px; color: #333; line-height: 60px; }
	> p:nth-child(2) { width: 677px; background: #fceead; }
	.isspecial,
	.nospecial {
		font-size: 14px; color: #333; padding: 20px;
	}
  .isspecial > span { color: #e33a3d; }
}
.new_price {
	margin-bottom: 20px;
	span {
		display: inline-block; font-size: 14px; color: #323232;
		&:nth-child(1) { width: 92px; text-align: right; }
		&:nth-child(2) { font-size: 24px; color: #e43a3d;
			i { color: #333; }
		}
	}
}
.level-discount {
	margin-bottom: 20px;
	span {
		display: inline-block; font-size: 14px; color: #323232;
		&:nth-child(1) { width: 92px; text-align: right; }
		&:nth-child(2) {
			background-color: #fb9e00; color: #ffffff; padding: 0 12px; font-style: italic; margin-left: 5px;
		}
	}
}
.btn_wrap { padding-bottom: 51px; border-bottom: 1px solid #eee;
	button {
		width: 210px; line-height: 55px; background: #e43a3d; font-size: 18px; color: #FFF; margin-left: 98px;
	}
	span {
		position: relative; margin-left: 13px; display: inline-block; width: 242px; height: 30px; background: #EEE; line-height: 30px; text-align: center; color: #666666; border-radius: 5px;
		.sanjiao {
			position: absolute; left: -6px;top: 10px; display: inline-block; border-top:6px solid transparent ; border-bottom: 6px solid transparent; border-right: 6px solid #EEE;
		}
	}
	.pay_submit {
		cursor: pointer; display: inline-block; line-height: 55px; width: 210px; background: #e43a3d; font-size: 18px; color: #FFF; margin-left: 98px; margin-top: 20px;
	}
	.stopserver { background: #C1C1C1; }
}
.easy_info { padding-top: 7px;
	.info { line-height: 44px; font-size: 16px; color: #666; font-weight: 600; }
	.detail { line-height: 25px; font-size: 14px; text-indent: 28px; color: #666; word-break: break-word; }
}
</style>
